function injectStyle (ssrContext) {
  require("!!../../../../yeepnflow/app/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../yeepnflow/app/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-02eebf49\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../yeepnflow/app/node_modules/vue-loader/lib/selector?type=styles&index=0!./wxbind.vue")
}
var normalizeComponent = require("!../../../../yeepnflow/app/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../yeepnflow/app/node_modules/vue-loader/lib/selector?type=script&index=0!./wxbind.vue"
import __vue_script__ from "!!babel-loader!../../../../yeepnflow/app/node_modules/vue-loader/lib/selector?type=script&index=0!./wxbind.vue"
/* template */
import __vue_template__ from "!!../../../../yeepnflow/app/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-02eebf49\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../yeepnflow/app/node_modules/vue-loader/lib/selector?type=template&index=0!./wxbind.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/wxbind.vue
// module id = null
// module chunks = 